import React from "react";
import { Badge } from "../ui";

interface StatusBadgeProps {
  status: string;
}

const toneFor = (status: string) => {
  const normalized = status.toLowerCase();
  if (normalized.includes("complete")) return "success" as const;
  if (normalized.includes("progress")) return "warning" as const;
  return "neutral" as const;
};

const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => (
  <Badge tone={toneFor(status || "")}>{status}</Badge>
);

export default StatusBadge;
